export const PLANET_RE = /@planet\.com$/;
export const PLANET_FEDERAL_RE = /@federal\.planet\.com$/;

export default function isPlanetEmployee(user) {
  return PLANET_RE.test(user.email) || PLANET_FEDERAL_RE.test(user.email);
}
